import { getAllMyResources, getIdentity } from "../../actions/api";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { List } from "antd";
import { DatabaseOutlined } from "@ant-design/icons";
import { PageHeader1 } from "../headers/PageHeaders";
import { clearResources } from "../../actions";
import { connect } from "react-redux";
import ManagedResourcesList from "./ManagedResourcesList";

const MyResources = ({
  resources,
  getAllMyResources,
  clearResources,
  loading,
  identity,
  getIdentity,
}) => {
  useEffect(() => {
    if (!identity) getIdentity();
  }, [getIdentity, identity]);

  useEffect(() => {
    // Make sure the list of resources is cleared before fetching new ones
    // to avoid showing stale data.
    // clearResources();
    getAllMyResources();
  }, [getAllMyResources, clearResources]);

  return (
    <div className="site-card-wrapper">
      <PageHeader1
        title="Managed Resources"
        subTitle="Resources are something you own for personal or official use: workspaces, databases, websites, etc."
        icon={<DatabaseOutlined />}
      />

      <List
        grid={{ gutter: 16, column: 1 }}
        loading={loading}
        dataSource={Object.keys(resources)}
        renderItem={(item) => (
          <List.Item>
            <ManagedResourcesList
              managedResourceTypeName={item}
              identityId={identity?.id}
            />
          </List.Item>
        )}
      />
    </div>
  );
};

MyResources.propTypes = {
  getAllMyResources: PropTypes.func.isRequired,
  clearResources: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  identity: PropTypes.object,
  getIdentity: PropTypes.func.isRequired,
  resources: PropTypes.object,
};

export default connect(
  (state) => ({
    resources: state.resources.data,
    loading: state.resources.loading,
    identity: state.identity,
  }),
  {
    getAllMyResources,
    clearResources,
    getIdentity,
  },
)(MyResources);
